import React, {useState} from "react";
import Preloader from "../../../ui/svg/common/preloader";
import AddAllItems from "../../../ui/svg/common/add-all-items";
import ChosenProducts from "./chosen-products";
import {useAppDispatch, useAppSelector} from "../DAL/store";
import {GetCurrentlyAddedMandatoryLine, ResetChart} from "../services/logic-helper";
import ProductPriceFormat from "../../products/product-price/product-price-format";


/**
 * Right Sticky Component - Your system description & "Buy from a dealer" button.
 */

const StickyBuyFromDealer = () => {

    const [showMandatoryError, setShowMandatoryError] = useState(false);
    const UserState_Cost = useAppSelector((store) => store.UserState_Cost);
    const UserState_CostLoading = useAppSelector((store) => store.UserState_CostLoading);
    const UserState_CategoriesIsMandatory = useAppSelector((store) => store.UserState_CategoriesIsMandatory);
    const UserState_AllMandatoryAdded = useAppSelector((store) => store.UserState_AllMandatoryAdded);
    const UserState_SelectedProducts = useAppSelector((store) => store.UserState_SelectedProducts);
    const UserState_SoftwareWasChosen = useAppSelector((store) => store.UserState_SoftwareWasChosen);
    const SBL_BuilderPage = useAppSelector((store) => store.SBL_BuilderPage);

    const dispatch = useAppDispatch();

    const CurrentMandatoryLine = GetCurrentlyAddedMandatoryLine(UserState_SelectedProducts,UserState_CategoriesIsMandatory);

    const OnBuyClick = () => {
        setShowMandatoryError(false);
        if(!UserState_AllMandatoryAdded){
            setShowMandatoryError(true);
            return;
        }
        const $el = document.getElementById('sendMailSection');
        if(!$el) return;

        $el.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
        const $focusEl = document.getElementById('emailInputEnter');

        if($focusEl) {
            $focusEl.focus();
        }

    }
    const classes = "flex flex-col border rounded py-6 px-6 bg-white max-w-full hidden lg:block md: w-1/3 xl:width-30p top-0 lg:top-60px xl:top-60px sticky self-start mx-auto";
    return (
        <div className={classes}>
            <div>
                <div className="flex items-center justify-between mb-6">
                    <div className="text-2xl font-bold">Your System</div>
                    <button type='button'    className="underline cursor-pointer" onClick={() => {
                        ResetChart(dispatch,SBL_BuilderPage);
                    }
                    }>Reset Cart</button>
                </div>
                <ChosenProducts />
                {!UserState_AllMandatoryAdded &&
                    <>
                        <div className="mt-6 bg-gray-100 px-4 py-6 border border-gray-150 rounded mt-4 text-sm">
                            <div className="flex items-center justify-around">
                                <AddAllItems width={"34px"}/>
                                <div className="text-center">
                                    <div className="w-full">
                                        Add all mandatory items to proceed.
                                    </div>
                                    {UserState_SoftwareWasChosen && <div className="w-full">{CurrentMandatoryLine}</div>}

                                </div>

                            </div>
                        </div>
                    </>

                }
                <div className="flex items-center justify-between px-4 py-4 text-xl font-bold">
                    <div className="">Total : </div>
                    <div className="">
                        {UserState_CostLoading ?
                            <div>
                                <Preloader width="25px" height="25px" color="#4f4f4f" />
                            </div>
                            :
                            <div className=""><ProductPriceFormat price={ UserState_Cost } /></div>
                        }
                    </div>
                </div>
                <div className="flex items-center justify-center">
                    <button type="button" onClick={OnBuyClick} className={`w-btn ${!UserState_AllMandatoryAdded ? "bg-gray-150 text-gray-500" : ""}`}>
                        Buy From A Dealer
                    </button>
                </div>
                {!UserState_AllMandatoryAdded && showMandatoryError && <div className="text-center text-red">Please select all mandatory items.</div>}

            </div>

        </div>
    );
};

export default StickyBuyFromDealer;
